import { Component, OnInit, Input } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { UntypedFormControl } from '@angular/forms';
import { Util } from 'src/app/util';
import { BaseButtonComponent } from '../base-button';

@Component({
  selector: 'app-calendar-button',
  templateUrl: './calendar-button.component.html',
  styleUrls: ['./calendar-button.component.scss'],
})
export class CalendarButtonComponent extends BaseButtonComponent implements OnInit {
  @Input()
  issueDates: string[] = [];

  date = new UntypedFormControl(new Date());
  selectedDate: string;

  ngOnInit() {
    this.date.setValue(Util.parseDate(this.issueDate));
  }

  availableFilter = (d: Date): boolean => {
    return this.issueDates.includes(this.formatDate(d));
  };

  onDateSelected(event: MatDatepickerInputEvent<Date>) {
    this.selectedDate = this.formatDate(event.value);
  }

  onClose() {
    if (this.selectedDate) {
      this.router.navigate(['/info', Util.slugifyRecord(this.record)], {
        queryParams: {
          issueDate: this.selectedDate,
        },
      });
    }
  }

  private formatDate(date: Date): string {
    return this.datePipe.transform(date, 'yyyyMMdd');
  }
}
